// extracted by mini-css-extract-plugin
export var chevron = "_1c-d";
export var disabled = "_1c-b";
export var error = "_1c-c";
export var hideBorder = "_1c-1";
export var icon = "_1c-e";
export var input = "_1c-0";
export var large = "_1c-f";
export var open = "_1c-9";
export var placeholder = "_1c-a";
export var regular = "_1c-5";
export var singleRowInput = "_1c-2";
export var singleSelectInput = "_1c-3 _1c-0";
export var small = "_1c-4";
export var spinnerContainer = "_1c-i";
export var tag = "_1c-7";
export var tagsContainer = "_1c-8";
export var tagsInput = "_1c-6 _1c-0";
export var xSmall = "_1c-g";
export var xxSmall = "_1c-h";